import { Breadcrumb, Button, Card, Table, Cell, Pagination, BookingStatusBadge, Input, Select, LoadingFullScreen } from 'components'
import { DateTime } from 'luxon'
import { getSearch, exportSearch } from 'api/search'
import { getAllDepartments, getClients, getDepartmentVenues } from 'api/clients'
import { getVenueGroups, getVenues } from 'api/venues'
import { getStatuses } from 'api/bookings'

export const Search = ({ attrs: { page, statusIds, sortBy, sortOrder, poNumber, search, reservationCode, clientId, departmentId, venueId, venueGroupId, fromDate, toDate, nightsTo, nightsFrom } }) => {
  const filters = {
    page: page || 1,
    bookingType: 1,
    statusIds: statusIds ? JSON.parse(statusIds) : [0, 1, 2],
    sortBy: sortBy || 'arrival',
    sortOrder: sortOrder || 'desc',
    poNumber: poNumber,
    search: search,
    reservationCode: reservationCode,
    clientId: clientId,
    departmentId: departmentId,
    venueId: venueId,
    venueGroupId: venueGroupId,
    fromDate: fromDate,
    toDate: toDate,
    nightsFrom: nightsFrom,
    nightsTo: nightsTo
  }

  let bookings = false
  let meta
  let departments
  let clients
  let venueGroups
  let statuses
  let criteriaReady = false
  let tableLoading = false
  let selectSearch
  let selectDepartment
  let selectVenue
  let exportLoading = false
  let venuesEnabled = false
  let venuesLoading = false

  Promise.all([
    getAllDepartments({ pagesize: 100 }),
    getClients({ pagesize: 100 }),
    getVenueGroups({ pagesize: 10000 }),
    getStatuses()
  ]).then(([d, c, v, s]) => {
    departments = d.data.map(row => {
      return { label: row.name, value: row.id, clientId: row.clientId }
    })
    clients = c.data.map(row => {
      return { label: row.name, value: row.id }
    })
    venueGroups = v.data.map(row => {
      return { label: row.name, value: row.id }
    })
    statuses = s.map(row => {
      return { label: row.name, value: row.id }
    })
    criteriaReady = true
  })

  const doSearch = () => {
    bookings = false
    tableLoading = true
    getSearch(filters).then(data => {
      tableLoading = false
      bookings = data.data
      meta = data.meta
      m.redraw()
    })

    var pageUrl = window.location.pathname + `?page=${filters.page || ''}&statusIds=${JSON.stringify(filters.statusIds)}&search=${filters.search || ''}&sortBy=${filters.sortBy || ''}&sort=${filters.sortOrder || ''}&poNumber=${filters.poNumber || ''}&reservationCode=${filters.reservationCode || ''}&clientId=${filters.clientId || ''}&departmentId=${filters.departmentId || ''}&venueId=${filters.venueId || ''}&venueGroupId=${filters.venueGroupId || ''}&fromDate=${filters.fromDate || ''}&toDate=${filters.toDate || ''}&nightsFrom=${filters.nightsFrom || ''}&nightsTo=${filters.nightsTo || ''}`
    window.history.pushState('', '', pageUrl)
  }

  // const refreshData = () => {
  //   getBookings(filters).then(data => {
  //     bookings = data.data
  //     meta = data.meta
  //   })
  // }

  return {
    view () {
      return [
        m(Breadcrumb, {
          links: [{
            title: `Search ${t('app', 'accommodation')}`
          }]
        }),
        m('.my-4.px-4',
          [
            criteriaReady ? m('form', {
              onsubmit (e) {
                e.preventDefault()
                doSearch()
              }
            }, [
              m(Card, {
                buttons: [
                  m(Button, {
                    type: 'button',
                    size: 'sm',
                    variant: 'plain',
                    loading: venuesLoading,
                    onclick () {
                      venuesLoading = true
                      getVenues({ pagesize: 10000, isActive: true, isAccommodation: true }).then(dv => {
                        const venues = dv.data.map(d => {
                          return {
                            label: d.name,
                            value: d.id
                          }
                        })
                        selectVenue.setChoices(venues, 'value', 'label', true)
                        venuesEnabled = true
                        venuesLoading = false
                      })
                    }
                  }, 'Load All Venues'),
                  m(Button, {
                    type: 'button',
                    loading: exportLoading,
                    onclick () {
                      exportLoading = true
                      exportSearch(filters).then(() => {
                        exportLoading = false
                      })
                    }
                  }, 'Export'),
                  m(Button, {
                    type: 'submit',
                    loading: tableLoading
                  }, 'Search')]
              }, m('.grid.grid-cols-12.gap-3', [
                m('.col-span-3', [
                  m(Select, {
                    label: 'Select a client',
                    value: filters.clientId,
                    choices: clients,
                    search: true,
                    required: false,
                    onchange (val, label) {
                      filters.clientId = val
                      selectDepartment.setChoices(departments.filter(d => {
                        return val === '' || d.clientId === Number(val)
                      }).map(d => {
                        return {
                          label: d.label,
                          value: d.value
                        }
                      }), 'value', 'label', true)
                    }
                  })
                ]),
                m('.col-span-3', [
                  m(Select, {
                    label: 'Select a department',
                    value: filters.departmentId,
                    choices: departments,
                    search: true,
                    required: false,
                    onchange (val, label) {
                      filters.departmentId = val
                      getDepartmentVenues(val, { pagesize: 1000 }).then(dv => {
                        const venues = dv.data.map(d => {
                          return {
                            label: d.venueName,
                            value: d.venueId
                          }
                        })
                        venuesEnabled = true
                        selectVenue.setChoices(venues, 'value', 'label', true)
                      })
                    },
                    instance (obj) {
                      selectDepartment = obj
                    }
                  })
                ]),
                m('.col-span-3', [
                  m(Select, {
                    label: 'Select a venue group',
                    value: filters.venueGroupId,
                    choices: venueGroups,
                    search: true,
                    required: false,
                    onchange (val, label) {
                      filters.venueGroupId = val
                    },
                    instance (obj) {
                      // selectVenueGroup = obj
                    }
                  })
                ]),
                m('.col-span-3', [
                  m(Select, {
                    label: 'Select a venue',
                    value: filters.venueId,
                    choices: [],
                    search: true,
                    required: false,
                    disabled: !venuesEnabled,
                    onchange (val, label) {
                      filters.venueId = val
                    },
                    instance (obj) {
                      selectVenue = obj
                    }
                  })
                ]),
                m('.col-span-11', [
                  m(Select, {
                    label: 'Select status(es)',
                    value: filters.statusIds,
                    choices: statuses,
                    search: true,
                    required: false,
                    subtype: 'multiple',
                    removeItemButton: true,
                    onchange (val) {
                      filters.statusIds = val
                    },
                    instance (obj) {
                      selectSearch = obj
                    }
                  })
                ]),
                m('.flex.items-end', [
                  m(Button, {
                    type: 'button',
                    size: 'sm',
                    onclick () {
                      selectSearch.removeActiveItems()
                      filters.statusIds = null
                    }
                  }, 'Clear all')
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'Date from',
                    value: filters.fromDate,
                    type: 'date',
                    oninput (value) {
                      filters.fromDate = value
                    },
                    dateInstance (obj) {
                    }
                  })
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'Date to',
                    value: filters.toDate,
                    type: 'date',
                    oninput (value) {
                      filters.toDate = value
                    }
                  })
                ]),
                m('div', [
                  m(Input, {
                    label: 'Nights from',
                    value: filters.nightsFrom,
                    type: 'number',
                    min: 1,
                    oninput (value) {
                      filters.nightsFrom = value
                    }
                  })
                ]),
                m('div', [
                  m(Input, {
                    label: 'Nights to',
                    value: filters.nightsTo,
                    type: 'number',
                    min: 1,
                    oninput (value) {
                      filters.nightsTo = value
                    }
                  })
                ]),
                m('.col-span-3', [
                  m(Input, {
                    label: 'Name / Email',
                    value: filters.search,
                    type: 'text',
                    oninput (value) {
                      filters.search = value
                    }
                  })
                ]),
                m('.col-span-1', [
                  m(Input, {
                    label: 'Res. Code',
                    value: filters.reservationCode,
                    type: 'text',
                    oninput (value) {
                      filters.reservationCode = value
                    }
                  })
                ]),
                m('.col-span-2', [
                  m(Input, {
                    label: 'PO Number',
                    value: filters.poNumber,
                    type: 'text',
                    oninput (value) {
                      filters.poNumber = value
                    }
                  })
                ])
              ])
              )
            ]) : m(LoadingFullScreen),
            m('div.shadow.h-full.border-b.border-gray-200.sm:rounded-lg',
              m(Table, {
                tight: true,
                cols: [
                  {
                    label: 'Name'
                  },
                  {
                    label: 'Email',
                    filterClasses: 'hidden'
                  },
                  {
                    label: 'Department',
                    classes: ['w-24']
                  },
                  {
                    label: 'Venue'
                  },
                  {
                    label: 'Location',
                    classes: ['w-24']
                  },
                  {
                    label: 'Res Code',
                    classes: ['w-32 justify-center']
                  },
                  {
                    label: 'PO Number',
                    classes: ['w-24 justify-center']
                  },
                  {
                    label: 'Arrival',
                    classes: ['w-24 justify-center']
                  },
                  {
                    label: 'Nights',
                    classes: ['w-20 justify-center']
                  },
                  {
                    label: 'Status',
                    classes: ['w-40 justify-center']
                  }
                ],
                filters: true,
                footer: meta && meta.totals
                  ? Object.keys(meta.totals).map(t => {
                    return [m('.flex', [m('span.font-bold', t + ':'), m('span.ml-1', meta.totals[t])])]
                  })
                  : false
              },
              [
                tableLoading ? m(LoadingFullScreen) : m('.overflow-auto.flex-grow',
                  bookings ? bookings.map((v, ix) => {
                    return m(BookingListItem, { item: v, key: v.id })
                  }) : m('p.text-center.p-3.text-gray-400', 'No results')
                ),
                meta && m(Pagination, {
                  meta: meta,
                  onpage: (page) => {
                    filters.page = page
                    getSearch(filters).then(data => {
                      bookings = data.data
                      meta = data.meta
                    })
                  }
                })
              ])
            )
          ])
      ]
    }
  }
}

const BookingListItem = ({ attrs: { item, classes = [], clientId, departmentId } }) => {
  const newFormat = { ...DateTime.DATE_SHORT, year: '2-digit', time: false }
  return {
    view () {
      const rowColor = 'bg-white'
      return m(m.route.Link, {
        class: ['flex', 'flex-shrink-0', 'hover:bg-gray-300', 'cursor-pointer', rowColor, ...classes].join(' '),
        href: `/clients/${item.clientId}/departments/${item.departmentId}/bookings/${item.id}`
      }, [
        m(Cell, { tight: true }, m('span', item.name)),
        m(Cell, { tight: true, cellClasses: ['tracking-tight'] }, m('span', item.email)),
        m(Cell, { width: 'w-24', tight: true },
          item.departmentName
        ),
        m(Cell, { tight: true, cellClasses: ['tracking-tight'] },
          item.venueName
        ),
        m(Cell, { width: 'w-24', tight: true, cellClasses: ['tracking-tight'] },
          item.venueTownCity ? item.venueTownCity.trim().split(' ').map((word) => {
            return word[0].toUpperCase() + word.substring(1).toLowerCase()
          }).join(' ') : ''
        ),
        m(Cell, { width: 'w-32', align: 'center', tight: true },
          item.reservationCode
        ),
        m(Cell, { width: 'w-24', align: 'center', tight: true },
          item.poNumber
        ),
        m(Cell, { width: 'w-24', align: 'center', tight: true },
          DateTime.fromISO(item.arrivalDate).toLocaleString(newFormat)
        ),
        m(Cell, { width: 'w-20', align: 'center', tight: true },
          item.nights
        ),
        m(Cell, { width: 'w-40', align: 'center', tight: true, noEllipsis: 'true' },
          m(BookingStatusBadge, {
            status: item.statusName, size: 'xs', margin: 'm-0'
          }
          )
        )
      ])
    }
  }
}
